module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125813.b9bb9a93.jpg";